import React from 'react'
import { MdCancel } from "react-icons/md";


function PaymentFailure({resultMsg, closePopUp}) {


  return (
    <div className='bg-[#F3EDED] text-black w-full h-[90vh] 
    flex flex-col justify-center items-center md:h-[80%] rounded-lg py-7 px-4 md:px-12'>
      
    <div className='space-y-4 text-center w-4/5'>
     <h3 className='text-3xl font-semibold'>Payment Error</h3>

        <MdCancel className='text-red-500 text-5xl mx-auto' />
      <p className='font-light text-md'>
      {resultMsg || `Oh no! There seems to be a problem with your selected payment method.
       Make sure your information is correct and please try again,`}
      </p>
    </div>

    <div className='flex flex-col justify-center items-center mt-10'>
      <button 
      onClick={() => {
        closePopUp()
      }}
      className='bg-greenCustom text-white font-semibold py-3 px-5 w-[200px] rounded-xl my-4
      transition-all ease-linear delay-300 transform hover:translate-x-4'>
      Try again</button>
    </div>
    </div>
  )
}

export default PaymentFailure
